import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductReference } from "src/app/models/layout/product-reference";
import { LayoutService } from 'src/app/services/layout.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-segment-brand-report-modal',
    templateUrl: './segment-brand-report-modal.component.html',
    styleUrls: ['./segment-brand-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, DecimalPipe]
})
export class SegmentBrandReportModalComponent implements OnInit {
  reportData: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private layoutService: LayoutService
  ) {}

  ngOnInit() {
    this.generateReport();
  }

  generateReport() {
    const products = this.layoutService.planogramItems;
    const actualFacingCounts = this.layoutService.getActualFacingCounts();

    // First group by segment
    const groupedBySegment = Array.from(products.values()).reduce((groups, product) => {
      const key = product.categoryLevel2;
      (groups[key] = groups[key] || []).push(product);
      return groups;
    }, {} as Record<string, ProductReference[]>);

    this.reportData = Object.entries(groupedBySegment)
      .map(([segment, segmentProducts]) => {
        const segmentTotalProducts = segmentProducts.length;
        const segmentTotalSales = segmentProducts.reduce((sum, p) => sum + p.salesData.sales, 0);
        const segmentTotalSalesQty = segmentProducts.reduce((sum, p) => sum + p.salesData.salesQty, 0);
        const segmentTotalFacings = segmentProducts.reduce((sum, p) => sum + (actualFacingCounts.get(p.productId) || 0), 0);

        // Group segment products by brand
        const groupedByBrand = segmentProducts.reduce((groups, product) => {
          const key = product.brand;
          (groups[key] = groups[key] || []).push(product);
          return groups;
        }, {} as Record<string, ProductReference[]>);

        const brandData = Object.entries(groupedByBrand)
          .map(([brand, brandProducts]) => {
            const totalSkus = brandProducts.length;
            const brandSales = brandProducts.reduce((sum, p) => sum + p.salesData.sales, 0);
            const brandSalesQty = brandProducts.reduce((sum, p) => sum + p.salesData.salesQty, 0);
            const brandFacings = brandProducts.reduce((sum, p) => sum + (actualFacingCounts.get(p.productId) || 0), 0);

            const rangeContribution = (100 / segmentTotalProducts) * totalSkus;
            const salesContribution = (100 / segmentTotalSales) * brandSales;
            const volumeContribution = (100 / segmentTotalSalesQty) * brandSalesQty;
            const planoFacings = segmentTotalFacings > 0 ? (100 / segmentTotalFacings) * brandFacings : 0;
            const volumeVariance = Math.abs(planoFacings) - Math.abs(volumeContribution);

            let varianceColor = 0;
            if (Math.abs(volumeVariance) > 3 && Math.abs(volumeVariance) < 5) {
              varianceColor = 1;
            } else if (Math.abs(volumeVariance) >= 5) {
              varianceColor = 2;
            }

            return {
              brand,
              totalSkus,
              rangeContribution,
              salesContribution,
              volumeContribution,
              planoFacings,
              volumeVariance,
              varianceColor
            };
          })
          .sort((a, b) => b.volumeContribution - a.volumeContribution);

        return {
          segment,
          brands: brandData,
          totalSkus: segmentTotalProducts,
          totalSales: segmentTotalSales,
          totalSalesQty: segmentTotalSalesQty,
          totalFacings: segmentTotalFacings
        };
      })
      .sort((a, b) => b.totalSalesQty - a.totalSalesQty);
  }

  close() {
    this.activeModal.close();
  }
}
